// External Libraries
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Utilities & Helpers
import { handleDeleteEntity } from "../../../utils/deleteHelper";
import checkPermissions from "../../global-functions/checkPermissionsFunc";

// Redux Actions
import { getCountriesFunc } from "../../../store/custom-actions/countries-actions/GetContriesSlicer";
import { deleteCountryFunc } from "../../../store/custom-actions/countries-actions/DeleteCountrySlicer";

// UI Components
import PageTitle from "../../layouts/PageTitle";
import SearchBox from "../../components/ui/SearchBox";
import Table from "../../components/ui/Table";
import Pagination from "../../components/ui/Pagination";
import LoadingScreen from "../../components/loading-screen/LoadingScreen";

// Custom Forms
import NewCountryForm from "../../custom-forms/countries/NewCountryForm";
import UpdateCountryForm from "../../custom-forms/countries/UpdateCountryForm";

export default function CountriesPage() {
  const { t } = useTranslation();
  const { loading: getCountriesLoading, data: countriesData } = useSelector(
    (state) => state.getCountriesSlicer
  );
  const { loading: deleteCountryLoading } = useSelector(
    (state) => state.deleteCountrySlicer
  );
  const [countriesList, setCountriesList] = useState([]);
  const [showNewCountryForm, setShowNewCountryForm] = useState();
  const [showUpdateForm, setShowUpdateForm] = useState();
  const [countryWichUpdate, setCountryWhichUpdate] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const getCitites = async () => {
      try {
        dispatch(getCountriesFunc());
      } catch (error) {
        console.log(error);
      }
    };
    getCitites();
  }, []);
  useEffect(() => {
    countriesData && setCountriesList(countriesData);
    countriesData &&
      (jobData.current = countriesData.slice(
        activePag.current * sort,
        (activePag.current + 1) * sort
      ));
  }, [countriesData]);
  const sort = 7;
  let paggination = Array(Math.ceil(countriesList.length / sort))
    .fill()
    .map((_, i) => i + 1);

  const activePag = useRef(0);
  const jobData = useRef(
    countriesList.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    )
  );
  const onClick = (i) => {
    activePag.current = i;
    jobData.current = countriesList.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    );
  };
  const search = () => {
    if (searchValue !== "") {
      const searchResult =
        countriesData &&
        countriesData.length >= 1 &&
        countriesData.filter((country) =>
          country.name
            .toLocaleLowerCase()
            .includes(searchValue.toLocaleLowerCase())
        );
      console.log(searchResult);
      jobData.current = searchResult;
    } else {
      dispatch(getCountriesFunc());
    }
  };
  useEffect(() => {
    searchValue == "" && dispatch(getCountriesFunc());
  }, [searchValue]);
  const handleDeleteItem = (id, entityName = "") => {
    handleDeleteEntity({
      id,
      entityName: entityName,
      deleteFunc: deleteCountryFunc,
      dispatch,
      refetchFunc: getCountriesFunc,
      t,
    });
  };
  return (
    <>
      <PageTitle motherMenu={"Dashboard"} activeMenu={"Countries"} />
      {!getCountriesLoading &&
        countriesList.length < 1 &&
        checkPermissions(
          "create addresses",
          <div className="relative mt-2 flex justify-end items-center">
            <Link
              to={"#"}
              className="btn btn-primary btn-sm"
              onClick={() => [setShowNewCountryForm(true)]}
            >
              {t("Create")}
            </Link>
          </div>
        )}
      <div className="col-12">
        <div className="card">
          <div className="card-header flex justify-between items-center">
            <SearchBox
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              onSearch={() => search()}
            />
            {checkPermissions(
              "create addresses",
              <Link
                to={"#"}
                className="btn btn-primary btn-md"
                onClick={() => [setShowNewCountryForm(true)]}
              >
                {t("Create")}
              </Link>
            )}
          </div>
          <div className="card-body">
            <div className="w-100 table-responsive">
              <div id="example_wrapper" className="dataTables_wrapper">
                <Table
                  showIndex={true}
                  startIndex={activePag.current * sort}
                  columns={[
                    { header: t("Name"), render: (row) => row.name },
                    { header: t("Code"), render: (row) => row.code },
                    {
                      header: t("Status"),
                      render: (row) => (
                        <span
                          className={`relative text-sm rounded-lg text-white ${
                            row.active == 1 ? "bg-green-500" : "bg-red-500"
                          } p-1`}
                        >
                          {row.active == 1 ? t("Active") : t("Not Active")}
                        </span>
                      ),
                    },
                    {
                      header: t("City"),
                      render: (row) => row?.cities_count || 0,
                    },
                    {
                      header: t("State"),
                      render: (row) => row?.states_count || 0,
                    },
                  ]}
                  data={jobData.current}
                  loading={getCountriesLoading}
                  actions={(country) => (
                    <>
                      {checkPermissions(
                        "update addresses",
                        <Link
                          to="#"
                          className="btn btn-primary shadow btn-xs sharp me-1"
                          onClick={() => {
                            setShowUpdateForm(true);
                            setCountryWhichUpdate(country);
                          }}
                        >
                          <i className="fas fa-pencil-alt"></i>
                        </Link>
                      )}
                      {checkPermissions(
                        "delete addresses",
                        <Link
                          to="#"
                          className="btn btn-danger shadow btn-xs sharp"
                          onClick={() => {
                            handleDeleteItem(country.id, country.name);
                          }}
                        >
                          <i className="fa fa-trash"></i>
                        </Link>
                      )}
                    </>
                  )}
                />
                <Pagination
                  totalItems={countriesList.length}
                  currentPage={activePag.current}
                  perPage={sort}
                  onPageChange={(page) => onClick(page)}
                  t={t}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <LoadingScreen loading={deleteCountryLoading} />
      <NewCountryForm
        show={showNewCountryForm}
        onHide={() => setShowNewCountryForm(false)}
      />
      <UpdateCountryForm
        show={showUpdateForm}
        onHide={() => setShowUpdateForm(false)}
        countryId={countryWichUpdate.id}
        oldName={countryWichUpdate.name}
        oldCode={countryWichUpdate.code}
        oldStatus={countryWichUpdate.active}
      />
    </>
  );
}
